import { createRouter, createWebHistory } from "vue-router";

const routes = [
    {
        path: "/",
        name: "layout",
        component: () => import("@/components/index.vue"),
        meta: {
            title: "Trang Chủ",
        },
        children: [
            // {
            //     path: "", // Empty path for root
            //     name: "overview",
            //     component: () => import("@/views/overview/index.vue"),
            //     meta: {
            //         title: "Tổng thể",
            //     },
            // },
            // {
            //     path: "flat/:id",
            //     name: "flat-id",
            //     component: () => import("@/views/flat/index.vue"),
            //     meta: {
            //         title: "Mặt Bằng",
            //     },
            // },
            // {
            //     path: "maps",
            //     name: "maps",
            //     component: () => import("@/views/maps/index.vue"),
            //     meta: {
            //         title: "Bản Đồ",
            //     },
            // },
            // {
            //     path: "info",
            //     name: "info",
            //     component: () => import("@/views/info.vue"),
            //     meta: {
            //         title: "Thông tin dự án",
            //     },
            // },
            // {
            //     path: "about",
            //     name: "about",
            //     component: () => import("@/views/about/index.vue"),
            //     meta: {
            //         title: "Tổng thể",
            //     },
            // },
            // DirectBar routes
            // {
            //     path: "location",
            //     name: "location",
            //     component: () => import("@/views/location/index.vue"),
            //     meta: {
            //         title: "Vị trí dự án",
            //     },
            // },
            // {
            //     path: "area/:id",
            //     name: "area",
            //     component: () => import("@/views/area/index.vue"),
            //     meta: {
            //         title: "Phân khu",
            //     },
            // },
            // {
            //     path: "exterior",
            //     name: "exterior",
            //     component: () => import("@/views/exterior/index.vue"),
            //     meta: {
            //         title: "Ngoại thất",
            //     },
            // },
            // {
            //     path: "exterior/:id",
            //     name: "exterior",
            //     component: () => import("@/views/exterior/index.vue"),
            //     meta: {
            //         title: "Ngoại thất",
            //     },
            // },
            // {
            //     path: "utilities/:id",
            //     name: "utilities",
            //     component: () => import("@/views/utilities/index.vue"),
            //     meta: {
            //         title: "Tiện ích",
            //     },
            // },
            // New routes for additional menu items
            // {
            //     path: "premises",
            //     name: "premises",
            //     component: () => import("@/views/premises/index.vue"),
            //     meta: {
            //         title: "Mặt bằng",
            //     },
            // },
            // {
            //     path: "interior/:id",
            //     name: "interior",
            //     component: () => import("@/views/interior/index.vue"),
            //     meta: {
            //         title: "Nội thất",
            //     },
            // },
            // {
            //     path: "brochure",
            //     name: "brochure",
            //     component: () => import("@/views/brochure/index.vue"),
            //     meta: {
            //         title: "E-Brochure",
            //     },
            // },
        ],
    },
    {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: () => import("@/views/404.vue"),
        meta: {
            title: "Not Found",
        },
    },
];

const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_BASE_URL),
    routes,
});

export default router;
